// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__IWVTl","productName":"Table_productName__2ZI6e"};